"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCookies = exports.rudderStackCookieFreeService = exports.isRudderStackInitialized = exports.rudderStackService = void 0;
const index_1 = require("../index");
const Analytics_helper_1 = require("./Analytics.helper");
const RUDDERSTACK_URL = "https://accurx-dataplane.rudderstack.com";
let initialized = false;
// Currently not tracking history through RudderStack as current volumes of pageViews can get very high (10s of millions per month)
// This kind of volume would use all of our current RudderStack allowance
const rudderStackService = () => {
    if (typeof window === "undefined")
        return null;
    // We import this dynamically so that accurx-shared can be imported into
    // a Next.js app (aka can be used server-side) since the
    // rudder-sdk-js library requires a window object to work
    // Note the require here as opposed to an ES6 import
    // This is because the rudder-sdk-js library requires a window object to be present
    // So we import like this so that accurx-shared can be imported into server-side rendered apps
    // eslint-disable-next-line @typescript-eslint/no-var-requires,@typescript-eslint/no-require-imports
    const rudderAnalytics = require("rudder-sdk-js");
    const initialize = (writeKey) => {
        if (!writeKey) {
            index_1.Log.error("RudderStack Write key not provided");
            return;
        }
        rudderAnalytics.load(writeKey, RUDDERSTACK_URL, {
            loadIntegration: false,
        });
        initialized = true;
    };
    const isInitialized = () => initialized;
    return { rudderAnalytics, initialize, isInitialized };
};
exports.rudderStackService = rudderStackService;
const isRudderStackInitialized = () => {
    const service = (0, exports.rudderStackService)();
    if (typeof window === "undefined" || !service) {
        return false;
    }
    return service.isInitialized();
};
exports.isRudderStackInitialized = isRudderStackInitialized;
const rudderStackCookieFreeService = () => {
    if (typeof window === "undefined")
        return null;
    const track = (eventName_1, ...args_1) => __awaiter(void 0, [eventName_1, ...args_1], void 0, function* (eventName, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    properties = {}) {
        if (typeof window === "undefined") {
            return {
                response: null,
                error: "Window does not exist",
            };
        }
        const getWriteKey = () => {
            const rudderStackWriteKey = index_1.AppSettings.getRudderStackWriteKey();
            if (rudderStackWriteKey === null || !window.btoa) {
                return "";
            }
            const encodedWriteKey = window.btoa(`${rudderStackWriteKey}:`);
            return `Basic ${encodedWriteKey}`;
        };
        const now = new Date();
        if (!window.crypto) {
            return {
                response: null,
                error: "window.crypto does not exist",
            };
        }
        if (!window.crypto.subtle) {
            return {
                response: null,
                error: "window.crypto.subtle does not exist",
            };
        }
        if (!window.navigator) {
            return {
                response: null,
                error: "window.navigator does not exist",
            };
        }
        if (!window.screen) {
            return {
                response: null,
                error: "window.screen does not exist",
            };
        }
        const hashedId = yield (0, Analytics_helper_1.generateUniqueDeviceId)();
        if (!hashedId)
            return {
                response: null,
                error: "Problem generating anonymousId",
            };
        const data = {
            event: eventName,
            properties: properties,
            userId: (properties === null || properties === void 0 ? void 0 : properties.userId) || "",
            anonymousId: hashedId,
            sentAt: now.toISOString(),
            originalTimestamp: now.toISOString(),
        };
        if (!window.btoa) {
            return {
                response: null,
                error: "window.btoa does not exist",
            };
        }
        const authHeaders = getWriteKey();
        if (!authHeaders) {
            return {
                response: null,
                error: "Problem fetching Rudderstack write key",
            };
        }
        const res = yield fetch(`${RUDDERSTACK_URL}/v1/track`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: authHeaders,
            },
            body: JSON.stringify(data),
        });
        return {
            response: res,
            error: "Rudderstack API call failed",
        };
    });
    return { track };
};
exports.rudderStackCookieFreeService = rudderStackCookieFreeService;
// Used to clear Rudderstack cookies from the patient portal
const clearCookies = () => {
    if (typeof window === "undefined")
        return;
    if (!window.document)
        return;
    if (!window.document.cookie)
        return;
    const rudderStackCookieNames = [
        "rl_user_id",
        "rl_trait",
        "rl_anonymous_id",
        "rl_group_id",
        "rl_group_trait",
        "rl_page_init_referrer",
        "rl_page_init_referring_domain",
    ];
    const allCookies = window.document.cookie.split("; ");
    const rudderStackCookies = allCookies.filter((cookie) => rudderStackCookieNames.indexOf(cookie.split("=")[0]) !== -1);
    if (rudderStackCookies.length === 0)
        return;
    for (let i = 0; i < rudderStackCookies.length; i++) {
        const cookieName = rudderStackCookies[i].split("=")[0];
        document.cookie =
            cookieName + "=; max-age=0; path=/; domain=.accurx.com";
    }
};
exports.clearCookies = clearCookies;
//# sourceMappingURL=RudderStackService.js.map